<template>
  <div>
    <heading>Sign in</heading>
    <form-message v-if="message"
                  :severity="msgSeverity"
                  :message="message"/>
    <password-form v-if="forcedPwChangeMethod"
                   @submit="completePwChange">
    </password-form>
    <login-form v-else
                @submit="login">
    </login-form>
  </div>
</template>

<script>
import { login } from '@/auth';

import Heading from './elements/Heading';
import FormMessage from './elements/FormMessage';

import LoginForm from './forms/Login';
import PasswordForm from './forms/Password';

export default {
  components: {
    Heading,
    FormMessage,
    LoginForm,
    PasswordForm,
  },

  data() {
    return {
      message: '',
      msgSeverity: 'information',
      forcedPwChangeMethod: false,
    };
  },

  props: {
    redirect: { type: String, default: '/' },
  },

  methods: {
    login: function tryLogin({ email, password }) {
      const self = this;

      login({
        password,
        username: email,
        success: () => self.$router.push(self.redirect),
        error: (msg) => {
          self.message = msg;
          self.msgSeverity = 'warning';
        },
        forcepw: method => self.initPwChange(method),
      });
    },

    initPwChange: function requestNewPassword(method) {
      this.message = 'A password reset is required, please enter a new password';
      this.msgSeverity = 'information';
      this.forcedPwChangeMethod = method;
    },

    completePwChange: function setNewPassword({ password }) {
      this.forcedPwChangeMethod({
        newPassword: password,
        family_name: '',
        given_name: '',
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Login.vue